module.exports = __webpack_public_path__ + "img/967.d451b76e.png";